export const nursingAllowanceDurationWidgetFragment = `
    id
    folderId
    durationDays
    folder {
        id
        serviceId
        person {
            id
            name
            surname
            dateDeath
        }
    }
`;

